"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuditEntityType = void 0;
exports.instanceOfAuditEntityType = instanceOfAuditEntityType;
exports.AuditEntityTypeFromJSON = AuditEntityTypeFromJSON;
exports.AuditEntityTypeFromJSONTyped = AuditEntityTypeFromJSONTyped;
exports.AuditEntityTypeToJSON = AuditEntityTypeToJSON;
exports.AuditEntityTypeToJSONTyped = AuditEntityTypeToJSONTyped;
/**
 *
 * @export
 */
exports.AuditEntityType = {
    Shift: 'Shift',
    Orientation: 'Orientation',
    OrientationOpportunity: 'OrientationOpportunity',
    License: 'License',
    Facility: 'Facility',
    PayrollEmployeeCheck: 'PayrollEmployeeCheck',
    Profile: 'Profile',
    ShiftTimeWorked: 'ShiftTimeWorked',
    Bonus: 'Bonus'
};
function instanceOfAuditEntityType(value) {
    for (const key in exports.AuditEntityType) {
        if (Object.prototype.hasOwnProperty.call(exports.AuditEntityType, key)) {
            if (exports.AuditEntityType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function AuditEntityTypeFromJSON(json) {
    return AuditEntityTypeFromJSONTyped(json, false);
}
function AuditEntityTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function AuditEntityTypeToJSON(value) {
    return value;
}
function AuditEntityTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=AuditEntityType.js.map